<template>
  <div
    class="
      page-content
    ">
    <section>
      <div
        class="
          filter-wrap content-wrap
        "
        style="
          margin-bottom: 0;
        ">
        <label
          style="
            font-size: 1rem;
          ">
          <b>
            ค้นหาลูกบ้าน
          </b>
        </label>
        <div
          class="
            filter input-text
          ">
          <input
            v-model="
              search.text
            "
            :placeholder="
              'ค้นหาชื่อนามสกุล, เบอร์มือถือ, หรือ อีเมล์'
            "
            type="text"
            class="
              el-input__inner
            "
            @keyup.enter="
              () => fetchUser(search.text, 1)
            "
          />
          <el-button
            type="sc-asset"
            icon="
              el-icon-search
            "
            @click="
              () => fetchUser(search.text, 1)
            ">
            ค้นหา
          </el-button>
        </div>
      </div>
    </section>

    <section>
      <div
        class="
          content-wrap content-main
        ">
        <p>
          พบ <b>{{ paging.total }}</b> รายการ
        </p>
        <div
          v-if="
            paging.total == 0
          "
          class="empty">
          <img
            src="@/assets/images/admin/empty.png"
          />
          <p>
            <b class="unknown">
              ไม่พบข้อมูล
            </b>
          </p>
        </div>
        <div
          v-if="
            paging.total > 0
          "
          class="user-list">
          <div
            v-for="
              (item, i) in items
            "
            :key="i"
            class="item">
            <div
              class="
                item-detail
              ">
              <b class="ellipsis">
                {{ item.firstName }} {{ item.lastName }}
              </b>
              <p class="subtitle">
                {{ display(item.mobileNo) }}
              </p>
            </div>
            <el-button
              type="sc-asset"
              icon="
                el-icon-edit-outline
              "
              @click="
                () => edit(item.id)
              ">
              เปิด
            </el-button>
          </div>
        </div>
        <div
          v-if="
            paging.total > 0
          ">
          <el-pagination
            :background="true"
            :layout="
              'prev, pager, next'
            "
            :pager-count="
              paging.count
            "
            :current-page="
              paging.page
            "
            :page-size="
              paging.limit
            "
            :total="
              paging.total
            "
            @current-change="
              (page) => fetchUser(
                search.text, page
              )
            "
          />
        </div>
      </div>
    </section>

    <!-- Loader -->
    <div 
      v-loading.fullscreen.lock="loader"
      element-loading-background="rgba(0, 0, 0, 0.4)">
    </div>
  </div>
</template>

<script>

// Utils
import { display } from '../../utils/phone'

// Services
// eslint-disable-next-line import/no-cycle
import { NonScFeature } from '../../feature'

export default {
  data () {
    
    // Init Title
    const title = 'รายการลูกบ้าน'

    // Init Loader
    const loader = false

    // Init Search
    const search = {
      text: null
    }
    
    // Init Paging
    const paging = {
      page  : 1,
      limit : 10,
      count : 5,
      total : 0,
    }

    // Init User
    const user = []

    return {
      title,
      loader,
      user,
      search,
      paging,
    }
  },
  computed: {
    clientUser() {
      return NonScFeature.user
    },
    items() {
      return this.user
    }
  },
  mounted() {

    // Init Title
    this.$emit(
      'sub-title', this.title
    )

    // Init User
    this.fetchUser()
  },
  methods: {
    display,
    edit(userId) {

      // Route Parameters
      const params = { userId }

      // Forward Route
      this.$router.push({
        name: 'nonsc-user-detail', params
      })
    },
    async fetchUser(text = '', page = 1) {
      
      // Loading
      this.loader = true

      try {
        
        // Paging Props
        const { limit } = this.paging

        // Fetch Params
        const params = {
          text, page, limit
        }
        
        // Fetch Home
        const { total, items } = (
          await this.clientUser.list(params)
        )

        // Set User
        this.user = items
        
        // Set Paging
        Object.assign(
          this.paging, { page, total }
        )
      }
      catch (_) {
        
        // Reset User
        this.user = []
        
        // Reset Paging
        Object.assign(
          this.paging, { page: 1, total: 0 }
        )
      }
      finally {
        setTimeout(
          () => { this.loader = false }, 400
        )
      }
    }
  }
}
</script>

<style lang="css" scoped>

section .content-wrap {
  background: white;
}

.content-main {
  display : grid;
  gap     : var(--size-md);
}

.user-list {
  display               : grid;
  gap                   : var(--size-sm);
  grid-template-columns : repeat(2, 1fr);
}

.item {
  padding     : var(--size-md);
  gap         : var(--size-sm);
  overflow    : hidden;
  align-items : center;
}

.item-detail {
  flex      : 1;
  overflow  : hidden;
}

.filter-wrap {
  margin-top: var(--size-md);
}

.filter {
  display : flex;
  gap     : var(--size-sm);
}

@media screen and (max-width: 1280px) {
    
  .user-list {
    grid-template-columns: 1fr;
  }
}

</style>
